import {
  GOTO_VIEW,
  UPDATE_API_PROCESSING,
  RESET_API_RETRY_COUNT,
  UPDATE_API_RETRY_COUNT,
  UPDATE_API_ERROR,
  GET_STARTED,
  SET_VERIFIED
} from "../actions/ui";

const UPDATE = "Update view";
const INITIAL_STATE = {
  activeView: "PickupFormView",
  apiProcessing: false,
  apiError: false,
  apiRetryCount: 0,
  getStarted: false,
  setVerified: false
};

export const uiReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE:
      return { ...state, ...action.payload };

    case GOTO_VIEW:
      return { ...state, activeView: action.payload };

    case UPDATE_API_PROCESSING:
      return { ...state, apiProcessing: action.payload };

    case UPDATE_API_ERROR:
      return { ...state, apiError: action.payload };

    case UPDATE_API_RETRY_COUNT:
      return { ...state, apiRetryCount: state.apiRetryCount + 1 };

    case RESET_API_RETRY_COUNT:
      return { ...state, apiRetryCount: 0 };

    case GET_STARTED:
      return { ...state, getStarted: true };
    
    case SET_VERIFIED:
      return { ...state, setVerified: true}

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/ui.js